(function () {
  var SECTION_SELECTOR = '[data-instagram-feed]';
  var SCRIPT_ID = 'instagram-embed-js';
  var SCRIPT_SRC = 'https://www.instagram.com/embed.js';

  function loadEmbed() {
    if (document.getElementById(SCRIPT_ID)) return;
    var s = document.createElement('script');
    s.id = SCRIPT_ID;
    s.src = SCRIPT_SRC;
    s.async = true;
    s.defer = true;
    document.body.appendChild(s);
  }

  function init() {
    var section = document.querySelector(SECTION_SELECTOR);
    if (!section) return;

    if (!('IntersectionObserver' in window)) {
      loadEmbed();
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            loadEmbed();
            obs.disconnect();
            break;
          }
        }
      },
      { rootMargin: '300px 0px', threshold: 0 }
    );

    observer.observe(section);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
